import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useNoIndex } from "@/hooks/useNoIndex";
import { LOGO_URL } from "@/data/sponsors";

export default function AdminLogin() {
  useNoIndex("Accesso riservato — DonnaImpresa");
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api
      .get("/auth/me")
      .then(() => navigate("/admin/richieste", { replace: true }))
      .catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", form);
      navigate("/admin/richieste", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-[#1A1617] px-5"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md rounded-[28px] bg-[#FAF9F6] p-8 sm:p-10">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="DonnaImpresa" className="h-11 w-11 rounded-xl object-cover" />
          <span className="font-display text-xl text-[#1A1617]">
            Donna<span className="text-[#E0708A]">Impresa</span>
          </span>
        </div>
        <h1 className="mt-8 font-display text-3xl tracking-tight text-[#1A1617]">
          Bacheca richieste
        </h1>
        <p className="mt-3 text-sm text-[#6B5E62]">
          Area riservata. Accedi per vedere le richieste arrivate dal sito.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.14em] text-[#5E2A52]">
              Email
            </label>
            <input
              type="email"
              required
              autoComplete="username"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="admin-login-email"
              className="mt-2 w-full rounded-2xl border border-[#E8E2E4] bg-white px-4 py-3 text-sm outline-none transition-colors duration-300 focus:border-[#E0708A]"
            />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.14em] text-[#5E2A52]">
              Password
            </label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              data-testid="admin-login-password"
              className="mt-2 w-full rounded-2xl border border-[#E8E2E4] bg-white px-4 py-3 text-sm outline-none transition-colors duration-300 focus:border-[#E0708A]"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#5E2A52] px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#E0708A] disabled:opacity-60"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Lock size={15} />}
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
